import React from "react";
import logo from "../../../images/logo_white1.png";
import "./login.css";
import "./host.css";
import { useNavigate } from "react-router-dom";

const HostIndex = () => {
  const navigate = useNavigate();

  return (
    <div className="host-index-bg d-flex align-items-center justify-content-center min-vh-100">
      <div className="card p-5" style={{ maxWidth: 420, width: "100%" }}>
        <div className="text-center mb-4">
          <img
            src={logo}
            alt="somadome logo"
            className="mb-3"
            style={{ maxWidth: 300, width: "50vw", minWidth: 100 }}
          />
        </div>
        <div className="d-grid gap-2">
          <button
            className="btn btn-light btn-lg fw-semibold text-secondary border-0 host-login-btn lato-bold-25u"
            onClick={() => navigate("/host/login")}
          >
            LOGIN
          </button>
          {/* <button
            className="btn btn-light btn-lg fw-semibold text-secondary border-0 host-login-btn lato-bold-25u"
            onClick={() => navigate("/host/register")}
          >
            CREATE ACCOUNT
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default HostIndex;
